module.exports = __webpack_public_path__ + "static/img/trading_platform.193a1a1.webp";


//////////////////
// WEBPACK FOOTER
// ./static/images2/trading_platform.webp
// module id = O9AR
// module chunks = 2